import {DynamicConfig} from '../models/DynamicConfig';
import {convertToStringArray, getSearchFilterPredefined, isFalse, isNullOrEmpty, isTrue} from '../utils';
import {
    defaultAdminRole,
    defaultApiTokenPath,
    defaultCountries,
    defaultCountry,
    defaultDisclaimerUrl,
    defaultDlsBackendUrl,
    defaultDlsIsEnabled,
    defaultDynamicConfig,
    defaultEditorRole,
    defaultLabelUrl,
    defaultLanguage,
    defaultLanguageOnlyMode,
    defaultLanguages,
    defaultPermissions,
    defaultRoleLength,
    defaultSpaceName,
    defaultStyleWordBreak,
    defaultSwapCountryLanguage,
    defaultTenant,
    defaultThumbnailUploadMaxSize,
    defaultUiComponentTemplates,
    defaultUiConfigurationTemplates,
    defaultUiIncludeFrok,
    defaultUseClientRoles,
    defaultUserRole,
    defaultWtmBackendUrl
} from './ui_configuration_defaults';
import {
    defaultDownloadCenterSearchPageSizeOptions,
    defaultDownloadCenterSearchParameterRecentlyAdded,
    defaultItemsHeaderLayout,
    defaultMainFilters,
    defaultPredefinedFilters,
    defaultSubFilters
} from './ui_component_defaults';

const convertToDynamicConfig = (jsExternalConfig: HTMLElement | null): DynamicConfig => {
    if ((jsExternalConfig?.innerHTML === undefined) || (!jsExternalConfig?.innerHTML)
        || (isNullOrEmpty(jsExternalConfig?.innerHTML)) || ('{}' === jsExternalConfig?.innerHTML.trim())) {
        return defaultDynamicConfig;
    }

    return JSON.parse(jsExternalConfig?.innerHTML) as DynamicConfig ?? defaultDynamicConfig;
};

const getTokenPath = (defaultApiTokenPathEnabled: string, customApiTokenPath: string): string => {
    if (isTrue(defaultApiTokenPathEnabled)) {
        return defaultApiTokenPath;
    }

    return (!isNullOrEmpty(customApiTokenPath)) ? customApiTokenPath.trim() : defaultApiTokenPath;
};

const getNumberOfItems = (noOfItemsIsEnabled: string, noOfItems: string[]): string[] => {
    if (isFalse(noOfItemsIsEnabled)) {
        return defaultDownloadCenterSearchPageSizeOptions;
    }

    return (noOfItems.length > 0) ? convertToStringArray(noOfItems) : defaultDownloadCenterSearchPageSizeOptions;
};

const isAuthorizationActive = isTrue(document.querySelector('meta[name=\'_authorized\']')?.getAttribute('content') ?? 'false');
const jsExternalConfig = convertToDynamicConfig(document.getElementById('js-externalConfig'));

export const config = {
    DLS_ENABLED: (!isNullOrEmpty(jsExternalConfig.downloadService.isEnabled)) ? isTrue(jsExternalConfig.downloadService.isEnabled) : defaultDlsIsEnabled,
    DLS_BACKEND_URL: (!isNullOrEmpty(jsExternalConfig.downloadService.backendUrl)) ? jsExternalConfig.downloadService.backendUrl.trim() : defaultDlsBackendUrl,
    WTM_ENABLED: false,
    WTM_BACKEND_URL: defaultWtmBackendUrl,
    DISCLAIMER_ENABLED: (!isNullOrEmpty(jsExternalConfig.downloadService.disclaimerIsEnabled ?? '')) ? isTrue(jsExternalConfig.downloadService.disclaimerIsEnabled) : false,
    DISCLAIMER_URL: (!isNullOrEmpty(jsExternalConfig.downloadService.disclaimerUrl ?? '')) ? jsExternalConfig.downloadService.disclaimerUrl.trim() : defaultDisclaimerUrl,
    LABEL_ENABLED: (!isNullOrEmpty(jsExternalConfig.downloadService.labelIsEnabled ?? '')) ? isTrue(jsExternalConfig.downloadService.labelIsEnabled) : false,
    LABEL_URL: (!isNullOrEmpty(jsExternalConfig.downloadService.labelUrl ?? '')) ? jsExternalConfig.downloadService.labelUrl.trim() : defaultLabelUrl,
    DLS_TENANT: (!isNullOrEmpty(jsExternalConfig.downloadService.tenant ?? '')) ? jsExternalConfig.downloadService.tenant.trim() : defaultTenant,
    DLS_SPACE_NAME: defaultSpaceName,
    DLS_UI_CONFIGURATION_TEMPLATES: defaultUiConfigurationTemplates,
    DLS_STORAGE_OBJECT_TEMPLATES: defaultUiComponentTemplates,
    DLS_AUTHENTICATION_ACTIVE: isAuthorizationActive,
    DLS_API_TOKEN_PATH: getTokenPath(jsExternalConfig.downloadService.useDefaultTokenPath, jsExternalConfig.downloadService.customTokenPath),
    DLS_USE_CLIENT_ROLES: defaultUseClientRoles,
    DLS_ROLE_LENGTH: defaultRoleLength,
    PERMISSIONS: jsExternalConfig.downloadService.permissions ? convertToStringArray(jsExternalConfig.downloadService.permissions) : defaultPermissions,
    DLS_ADMIN_ROLE_NAME: defaultAdminRole,
    DLS_EDITOR_ROLE_NAME: defaultEditorRole,
    DLS_USER_ROLE_NAME: defaultUserRole,
    LANGUAGE_ONLY_MODE_ACTIVE: (!isNullOrEmpty(jsExternalConfig.downloadService.languageOnlyModeActive ?? '')) ? isTrue(jsExternalConfig.downloadService.languageOnlyModeActive) : defaultLanguageOnlyMode,
    SWAP_COUNTRY_LANGUAGE_ACTIVE: (!isNullOrEmpty(jsExternalConfig.downloadService.swapCountryLanguageActive ?? '')) ? isTrue(jsExternalConfig.downloadService.swapCountryLanguageActive) : defaultSwapCountryLanguage,
    DLS_COUNTRY_DEFAULT: defaultCountry,
    DLS_LANGUAGE_DEFAULT: defaultLanguage,
    DLS_COUNTRIES: jsExternalConfig.downloadService.countries ? convertToStringArray(jsExternalConfig.downloadService.countries).map(country => country.toUpperCase()) : defaultCountries,
    DLS_LANGUAGES: jsExternalConfig.downloadService.languages ? convertToStringArray(jsExternalConfig.downloadService.languages).map(country => country.toLowerCase()) : defaultLanguages,
    DLS_DOWNLOAD_INCLUDE_FROK: defaultUiIncludeFrok,
    DLS_THUMBNAIL_MAX_SIZE: defaultThumbnailUploadMaxSize,
    DLS_WORD_BREAK: defaultStyleWordBreak,
    DLS_LAYOUT: (!isNullOrEmpty(jsExternalConfig.downloadService.layout ?? '')) ? jsExternalConfig.downloadService.layout : defaultItemsHeaderLayout,
    NO_OF_RECENT_DAYS: (jsExternalConfig.downloadService.recentlyAddedDays > 0) ? jsExternalConfig.downloadService.recentlyAddedDays : defaultDownloadCenterSearchParameterRecentlyAdded,
    NO_OF_ITEMS: getNumberOfItems(jsExternalConfig.downloadService.noOfItemsIsEnabled, jsExternalConfig.downloadService.noOfItems),
    MAIN_FILTERS: jsExternalConfig.downloadService.mainFilters ? convertToStringArray(jsExternalConfig.downloadService.mainFilters) : defaultMainFilters,
    SUB_FILTERS: jsExternalConfig.downloadService.subFilters ? convertToStringArray(jsExternalConfig.downloadService.subFilters) : defaultSubFilters,
    PREDEFINED_FILTERS: jsExternalConfig.downloadService.predefinedFilters ? getSearchFilterPredefined(jsExternalConfig.downloadService.predefinedFilters) : defaultPredefinedFilters
};
